import i18n from "@/i18n";
import { SET } from "../CommumActionTypes";

const mutations = {
	[SET]: (state, locale) =>
	{
		state.locale = locale;
	},
};

export default { mutations };